let ApiaccesslogService = function (Restangular) {
  const Service = Restangular.all('admin/log');

  let count = (query) => {
    query = query || {};
    return Service.customGET('count', query);
  } 

  let save = (resource) => {
    if (resource.save) {
        return resource.save();
    } else {
        return Service.post(resource);
    }
  }

  let index = (query) => {
    query = query || {};
    return Service.getList(query);
  }

  let load = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
      count(query)
      .then(response => {
          let count = response[0];
          index(query)
          .then(data => {
              resolve({count, data});
          })
          .catch(err => {
              reject(err);
          });
      })
      .catch(err => {
          reject(err);
      });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  }

  return { index, load, save, show, destroy, count } ;
};

ApiaccesslogService.$inject = ['Restangular'];

export default ApiaccesslogService;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog.service.js